export default __webpack_public_path__ + "static/media/9882.3dcc291c.png";